module.exports = __webpack_public_path__ + "static/media/HomeScreen_elImage3_969349285.b431ef37.png";